import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  listDashboardBuilderDrafts,
  type DashboardBuilderDraftSummary,
} from '../components/coach/dashboard-builder/dashboardBuilderDraftStorage';

export function useDashboardBuilderDrafts(): DashboardBuilderDraftSummary[] {
  const { user } = useAuth();
  const userId = user?.id;

  const readDrafts = useCallback((): DashboardBuilderDraftSummary[] => {
    if (!userId) return [];
    return listDashboardBuilderDrafts(userId);
  }, [userId]);

  const [drafts, setDrafts] = useState<DashboardBuilderDraftSummary[]>(readDrafts);

  useEffect(() => {
    setDrafts(readDrafts());
  }, [readDrafts]);

  useEffect(() => {
    if (!userId) return;

    const refresh = () => setDrafts(readDrafts());

    const onStorage = (event: StorageEvent) => {
      if (event.key == null || event.key.includes('coach-dashboard-builder-draft')) {
        refresh();
      }
    };

    window.addEventListener('storage', onStorage);
    window.addEventListener('glyyd:dashboard-builder-draft-changed', refresh);

    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('glyyd:dashboard-builder-draft-changed', refresh);
    };
  }, [userId, readDrafts]);

  return drafts;
}
